import type { IconData } from '@stacksjs/iconify-core'

export const iceCream2Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.666 10.81A179 179 0 0 0 7.5 19c0 3.378.067 6.066.166 8.19c.24 5.2 4.11 8.96 9.28 9.177c1.902.08 4.232.133 7.054.133s5.152-.054 7.054-.133c5.17-.216 9.04-3.976 9.28-9.176c.099-2.124.166-4.813.166-8.191s-.067-6.067-.166-8.191c-.24-5.2-4.11-8.96-9.28-9.176C29.152 1.553 26.822 1.5 24 1.5s-5.152.054-7.054.133c-5.17.216-9.04 3.976-9.28 9.176ZM20.5 13a1.5 1.5 0 0 0-3 0v12a1.5 1.5 0 0 0 3 0zm8.5-1.5a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 3 0V13a1.5 1.5 0 0 0-1.5-1.5M17.88 40.47l.173-1.56c1.69.055 3.662.09 5.947.09s4.256-.035 5.947-.09l.174 1.56c.29 2.605-1.322 5.229-4.076 5.775c-.679.134-1.436.255-2.045.255c-.61 0-1.366-.121-2.045-.255c-2.754-.546-4.366-3.17-4.076-5.775Z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default iceCream2Solid
